export default "__VITE_ASSET__C1FBM6pp__"